import getters from './getters';
import actions from './actions';
import mutations from './mutations'
const state = {
   labor : {
    description: '',
    cost: '',
    serviceId : null,
    serviceCategoryId : null,
    service : {}
   },
   laborCosts : []
}

const labor = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default labor;